<template>
  <v-row class="ma-0 mb-n6">
    <v-expansion-panels class="my-5" @update:model-value="marcarEstadoPanel()" v-model="panelOpen">
      <v-expansion-panel class="rounded-panel mb-5" rounded="m" :bg-color="expPanel.color">
        <v-expansion-panel-title expand-icon="mdi-plus-circle-outline" collapse-icon="mdi-minus-circle-outline">
          <h3 class="fMontserrat" style="color: white">{{ panel.title }}</h3>
        </v-expansion-panel-title>
        <v-expansion-panel-text :style="{ 'background-color': expPanel.subColor }" class="rounded-panelText">
          <v-row class="ma-0 pa-0">
            <v-col cols="12" class="text-h5 greenText py-0">{{t('prescription')}}</v-col>
            <v-col lg="6" cols="12">
              <v-card rounded="lg" color="#bbbbbb" class="fMontserrat text-black">
                <v-card-title class="font-weight-bold"> {{t('rightLens')}}</v-card-title>
                <v-card-text>
                  <span class="fMontserrat" v-html="formatContent(expPanel.ojoD)" />
                </v-card-text>
              </v-card>
            </v-col>
            <v-col lg="6" cols="12">
              <v-card rounded="lg" color="#bbbbbb" class="fMontserrat text-black">
                <v-card-title class="font-weight-bold"> {{t('leftLens')}}</v-card-title>
                <v-card-text>
                  <p class="fMontserrat" v-html="formatContent(expPanel.ojoI)" />
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row class="ma-0 pa-0">
            <v-col cols="12" class="text-h5 greenText py-0">{{t('yourLenses')}}</v-col>
            <v-col cols="12">
              <v-card rounded="lg" color="#088E4B" class="fMontserrat">
                <v-card-title class="font-weight-bold"> {{ expPanel.TipoLente }}</v-card-title>
                <v-card-text>
                  <!-- <v-row>
                        <v-col cols="12"> ESFERA CILINDRO ADICION</v-col>
                    </v-row> -->
                  <h3 class="fMontserrat">{{t('treatment')}}</h3>
                  <p class="fMontserrat" v-html="formatContent(expPanel.tratamientos)" />
                  <h3 class="fMontserrat">{{t('material')}} / {{t('index')}}</h3>
                  <p class="fMontserrat" v-html="formatContent(expPanel.materialIndice)" />
                  <h3 class="fMontserrat">{{t('color')}}</h3>
                  <p class="fMontserrat" v-html="formatContentOrHyphen(expPanel.coloracion)" />
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-row>
</template>

<script setup>
import { ref, defineProps } from "vue";
import { t } from "../functions/translation.js";

const props = defineProps({ panel: Object });
var expPanel = ref(props.panel);
const formatContent = (content) => {
  return content.replace(/\n/g, "<br>");
};
const formatContentOrHyphen = (content) => {
  return content === "" ? "-" : content.replace(/\n/g, "<br>");
};

const panelOpen = ref(0);
const marcarEstadoPanel = () => {
  panelOpen.value = panelOpen.value === 0 ? undefined : 0;
};

if (props.panel.datosOT) {
  var od = props.panel.datosOT.Ojos.find((x) => x.Ojo === "D");
  var oi = props.panel.datosOT.Ojos.find((x) => x.Ojo === "I");
  // expPanel.value.ojoD = `<p style="font-weight: bold;">Esfera  Cilindro  Eje Adicion</p>
  //                       <p>${od.Esfera.toFixed(2)} ${od.Cilindro.toFixed(2)} ${od.Eje} ${od.Adicion}</p>`;
  expPanel.value.ojoD = `<table class="centered-table fMontserrat"><tr class="header-row"> <td>${t('sphere')}</td><td>${t('cylinder')}</td><td>${t('axis')}</td><td>${t('addition')}</td></tr><tr><td>${od.Esfera.toFixed(
    2
  )}</td><td>${od.Cilindro.toFixed(2)}</td><td>${od.Eje}</td><td>${od.Adicion}</td></tr></table>`;
  expPanel.value.ojoI = `<table class="centered-table fMontserrat"><tr class="header-row"> <td>${t('sphere')}</td><td>${t('cylinder')}</td><td>${t('axis')}</td><td>${t('addition')}</td></tr><tr style="text-align: center;"><td>${oi.Esfera.toFixed(
    2
  )}</td><td>${oi.Cilindro.toFixed(2)}</td><td>${oi.Eje}</td><td>${oi.Adicion}</td></tr></table>`;
  expPanel.value.TipoLente = `${props.panel.datosOT.TipoLente}`;
}
// var content1 = `<p style="font-weight: bold;"> ${t("pedido")}: #OT# </p> ${t(
//   "graduacion"
// )}: <br> OD: #OD# OI: #OI#`;
// content1 = content1
//   .replace("#OT#", OT.value)
//   .replace("#OD#", od.Esfera)
//   .replace("#OI#", oi.Esfera);
</script>

<style>
.movedIcon {
  position: absolute;
  top: 0px;
  left: 0px;
}

.fMontserrat {
  font-family: Montserrat;
}

.rounded-panel {
  border-radius: 8px !important;
}

.rounded-panelText {
  border-radius: 0% 0% 8px 8px;
}
.blackText {
  color: black;
}

.greenText {
  color: #088e4b;
}


.fMontserrat {
  font-family: 'Montserrat', sans-serif;
}

.centered-table {
  width: 100%;
  border-collapse: collapse;
}
.centered-table td, .centered-table th {
  text-align: center;
}
.header-row {
  font-weight: bold;
}

</style>
